"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BookingCalendarModal = require("./BookingCalendarModal");
Object.keys(_BookingCalendarModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BookingCalendarModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BookingCalendarModal[key];
    }
  });
});